import { render, staticRenderFns } from "./TopTask.vue?vue&type=template&id=14118481&scoped=true"
import script from "./TopTask.vue?vue&type=script&lang=ts"
export * from "./TopTask.vue?vue&type=script&lang=ts"
import style0 from "./TopTask.vue?vue&type=style&index=0&id=14118481&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14118481",
  null
  
)

export default component.exports